'use client';
import { useRef } from 'react';
import { useToggle } from '@/hooks/useToggle';
import { SUPPORT_LINK } from '@/constants/links';
import { OpenExternalIcon, SettingsIcon, SupportIcon } from '@/icons';
import Menu, { MenuDivider, MenuItem } from '@/components/Menu';
import AppearanceToggle from './AppearanceToggle';
import { classes } from './utils';

export default function SettingsMenu() {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [isOpen, toggleOpen] = useToggle(false);

  const handleOpenSupport = () => {
    window.open(SUPPORT_LINK, '_blank', 'noopener,noreferrer');
    toggleOpen(false);
  };

  return (
    <>
      <button
        ref={triggerRef}
        aria-label="Settings"
        className={classes.trigger}
        onClick={() => toggleOpen()}>
        <SettingsIcon fontSize="small" />
      </button>
      <Menu
        open={isOpen}
        anchorTo={triggerRef.current}
        onClose={() => toggleOpen(false)}>
        <div className={classes.sectionLabel}>Appearance</div>
        <div className={classes.appearance}>
          <AppearanceToggle />
        </div>
        <MenuDivider />
        <MenuItem
          label="Help Center"
          icon={<SupportIcon fontSize="small" />}
          endIcon={<OpenExternalIcon />}
          onClick={handleOpenSupport}
        />
      </Menu>
    </>
  );
}
